module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-panel",
    class: {
      'is-pinned': _vm.isPinned,
      'is-scroll-disabled': _vm.isScrollDisabled,
      'has-padding': _vm.hasPadding
    },
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e61711"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/scrollPanel/ScrollPanel.vue
// module id = 1836
// module chunks = 0